import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('discardReplyOption')(function discardReplyOption(state) {
    var optionState = state.optionState;
    optionState.replyAllByDefault = null;
}));
//# sourceMappingURL=discardReplyOption.js.map